
import React, { useState } from 'react';
import { Button, Modal,Input,Space,Tag } from 'antd';
import {useNavigate} from 'react-router-dom'
import { functionService } from '../../lib/functions';

const InviteeModal  = ({isOpen,setOpen,id}) => {

  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState([]);

const addMoreInvitee=async()=>{

try {
  const {response}=await functionService.post('machineinterview/addInvitee',{
    email:emails,
    test_id:id,
  })
  if(response.status===200){
    setOpen(false)
    setEmails([])
  }
} catch (error) {
  console.log(error)
}

    
}


  const handleOk = async() => {
    try {
      
        const data= await addMoreInvitee()
        console.log(data,"===================>")
    } catch (error) {
        
    }

  };

  const handleCancel = () => {
    setEmails([])
    setOpen(false);
  };
  const handleTagAdd = () => {
    if (inputValue && !emails.includes(inputValue)) {
      setEmails([...emails, inputValue]);
      setInputValue('');
    }
  };
  const handleTagRemove = (tag) => {
    const updatedTags = emails.filter((t) => t !== tag);
    setEmails(updatedTags);
  };
  const navigate=useNavigate()

console.log(emails,"EMAILS")
  return (
    <>
  
      <Modal
        open={isOpen}
        onOk={handleOk}
        style={{padding:'75px 0'}}
        onCancel={handleCancel}
        footer={[
        ]}
      >  
   <>
        <p style={{textAlign:'center',fontSize:'20px',fontWeight:600}}>Send Invitation</p>


   
        <Space style={{display:'flex',justifyContent:'flex-start',flexWrap:'wrap',border:'1px solid #C8CACC',alignItems:'flex-start',padding:'10px',height:'120px',overflow:'scroll'}} >
          {emails.map((tag) => (
            <Tag
            style={{display:'flex',alignItems:'center',fontSize:'11px',fontWeight:'500',borderColor:'#1B49EA'}}
            color='processing'
            bordered={false}
              key={tag}
              closable
              onClose={() => handleTagRemove(tag)}
            >
              {tag}
            </Tag>
          ))}
         
    
    <Input
    style={{height:'20px',borderRadius:'8px',width:'250px'}}
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      type="text"
      size="small"
      onPressEnter={handleTagAdd}
      bordered={false}
      placeholder='Enter addresses (comma separated)'
    />

        </Space>
     
     <div style={{display:'flex',height:'50px',marginTop:'30px',gap:'60px'}} >
     <Button key="submit" type="primary"  onClick={handleCancel} style={{padding:'0 30px',margin:'0 200px 0 0',backgroundColor:'#e6eafa',color:'#1B49EA'}} >
Cancel
           </Button>
             <Button key="submit" type="primary"  onClick={handleOk} style={{padding:'0 30px',backgroundColor:'#1B49EA',margin:'0 200px 40px 0',border:'1px solid green'}} >
         Invite
           </Button>
          
   
           </div>
       </>
      </Modal>
      
    </>
  );
};

export default InviteeModal ;